const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
    },
    container: {
        maxWidth: '100%',
        mt: '24px',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '48px',
        color: '#090C39',
        textTransform: 'capitalize',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: '36px',
        color: '#8697AB',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '32px',
        marginBottom: '32px',
    },
    table: {
        padding: '24px',
        borderRadius: '16px',
        mt: 3,
        boxShadow: '0px 30px 30px rgba(151, 172, 191, 0.08), 0px 0px 30px rgba(151, 172, 191, 0.12)',
    },
    count: {
        background: '#FFFFFF',
        color: '#8697AB',
        padding: '4px',
        borderRadius: '8px',
        ml: 2,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
    },
    selectedFilters: {
        gap: '20px',
    },
    chip: {
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'Silka_Regular',
        lineHeight: '16px',
        height: '24px',
        backgroundColor: 'rgba(61, 135, 191, 0.1)',
        borderWidth: 0,
    },
    chipDelete: {
        mt: '-10px !important',
    },
    partner: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: '10px',
        alignItems: 'center',
    },
    addPartner: {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        marginLeft: 'auto',
    },
    addIcon: {
        ml: 1,
        alignItems: 'center',
    },
    allPartnerButton: {
        borderRadius: '16px 0 0 16px',
        height: '40px',
        borderColor: '#d6d6d6',
    },
    allMemberButton: {
        borderRadius: '0 16px 16px 0',
        height: '40px',
        borderColor: '#d6d6d6',
    },
    tabIndicator: {
        backgroundColor: 'transparent',
    },
    addMember: {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        marginLeft: 'auto',
        width: '164px',
        height: '48px',
        borderRadius: '16px',
        cursor: 'pointer',
    },
    emptyResults: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#4D5C71',
    },
    addMemberText: {
        position: 'absolute',
        height: '21px',
        left: '16px',
        right: '48px',
        top: 'calc(50% - 21px/2 + 0.5px)',
        fontFamily: 'Silka',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        color: '#FFFFFF',
    },
    addMemberIcon: {
        position: 'absolute',
        right: '14.68%',
        bottom: '28.63%',
        ml: 1,
        alignItems: 'center',
        color: '#FFFFFF',
        background: '#FFFFFF',
    },
    member: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: '10px',
        alignItems: 'center',
    },
};
export default styles;
